import React, { FC } from 'react';
import { User } from './types';
import { getUserMentionClassName, getRemovedUserName } from './utils';

type Props = {
  description: string;
  id: string;
  user?: User;
  projectUser?: User;
  isComment?: boolean;
  isPrivate?: boolean;
};

export const UserMention: FC<Props> = ({
  description,
  id,
  user,
  projectUser,
  isComment,
  isPrivate
}) => (
  <span
    className={getUserMentionClassName({
      projectUser,
      user,
      isComment,
      isPrivate,
      id
    })}
  >
    {`@${projectUser?.name || getRemovedUserName(id, description) || id}`}
  </span>
);
